import React, { useState, forwardRef } from 'react';
import { LoadingPage } from "../../components";

const TournamentGame = forwardRef(({ url, size }, ref) => {
  const [isLoading, setLoading] = useState(true);

  const urlIsCorrect = typeof url === 'string';
  const hideLoading = () => setLoading(false);

  return (
    <div className={'tournaments__game__iframe-wrapper game game--mobile'}>
      {isLoading && <LoadingPage
        type='tournament'
        onClose={ () => setLoading(false)}
        />
      }
      {urlIsCorrect && (<iframe
        className={`tournaments__game__iframe  ${size}`}
        onLoad={hideLoading}
        src={url}
        width='100%'
        height='100%'
        allowFullScreen={undefined}
        ref={ref}
      />)}
      {!urlIsCorrect && (<div className="tournaments__game__error-message">
        {url ? url[0] : 'Server is not responding'}
      </div>)}
    </div>
  );
});

export default TournamentGame;